<template>
  <EmptyState
    class="empty-dashboard"
    :title="t('emptyDashboard.title')"
    :description="canCreateWidget ? t('emptyDashboard.subtitle') : null"
    bordered
  >
    <Button
      v-if="canCreateWidget"
      type="primary"
      icon="iconoir-plus"
      @click="openCreateWidgetModal"
      >{{ t('emptyDashboard.addWidget') }}</Button
    >
    <template #outside>
      <CreateWidgetModal
        ref="createWidgetModal"
        :dashboard="dashboard"
        @widget-variation-selected="$emit('widget-variation-selected', $event)"
      />
    </template>
  </EmptyState>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useNuxtApp } from '#app'
import CreateWidgetModal from '@baserow/modules/dashboard/components/CreateWidgetModal'

const props = defineProps({
  dashboard: {
    type: Object,
    required: true,
  },
})

defineEmits(['widget-variation-selected'])

const { t } = useI18n()
const { $hasPermission } = useNuxtApp()

const createWidgetModal = ref(null)

const canCreateWidget = computed(() => {
  if (!props.dashboard?.workspace?.id) {
    return false
  }
  return $hasPermission(
    'dashboard.create_widget',
    props.dashboard,
    props.dashboard.workspace.id
  )
})

const openCreateWidgetModal = () => {
  createWidgetModal.value?.show()
}
</script>
